import {TacticalPlan} from "./TacticalPlan";
import {TacticalPlanRule} from "./TacticalPlanRule";
import {type SimpleZoneType} from "../Zones/ZoneApi";
import type {ZoneListType} from "./CurrentZoneListStore";

export interface TacticalPlanContextInterface {
    tp: TacticalPlan;
    tprules: TacticalPlanRule[];
    zones: SimpleZoneType[];
    tpZoneLists: ZoneListType[];
    currentRuleId: number|null
}

export class TacticalPlanContext {
    private tp: TacticalPlan;
    private tprules: TacticalPlanRule[];
    private zones: SimpleZoneType[];
    private tpZoneLists: ZoneListType[];
    private currentRuleId: number|null;

    constructor(tp: TacticalPlan, tprules: TacticalPlanRule[], zones: SimpleZoneType[], currentRuleInnerId: string|null, tpZoneLists: ZoneListType[]=[]) {
        this.tp = tp;
        this.tprules = tprules;
        this.zones = zones;
        this.tpZoneLists = tpZoneLists;
        this.currentRuleId = tprules.find(rule => rule.getInnerId() === currentRuleInnerId)?.getId() ?? null;
    }

    getContext(): TacticalPlanContextInterface {
        return {
            tp: this.tp,
            tprules: this.tprules,
            zones: this.zones,
            tpZoneLists: this.tpZoneLists,
            currentRuleId: this.currentRuleId
        };
    }

}